import React from "react";
import { ArrowUpRight } from "lucide-react";
import { resolveImage } from "../lib/api";

const NAV = [
  { label: "Work", href: "#work" },
  { label: "Toolkit", href: "#toolkit" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

const Footer = ({ site }) => {
  const f = site?.footer || {};
  const socials = site?.socials || {};
  const voxel = site?.voxel_assets || {};

  return (
    <footer className="relative bg-[color:var(--ink)] text-[color:var(--bg)] overflow-hidden">
      {/* Waving character — sits at bottom-right, transparent so it blends naturally */}
      {voxel.footer && (
        <img
          data-testid="footer-voxel"
          src={resolveImage(voxel.footer)}
          alt="Bye!"
          className="hidden md:block absolute right-6 lg:right-16 bottom-0 w-56 lg:w-80 h-auto mk-drift pointer-events-none select-none"
          draggable={false}
        />
      )}

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl">
          <div className="text-sm tracking-wider uppercase text-[color:var(--bg)]/60">
            Let&apos;s collaborate
          </div>
          <h3 className="mt-3 font-display text-4xl md:text-6xl font-semibold leading-[1.0]">
            {f.tagline_pre || "Got an idea that needs a"}{" "}
            <em className="italic text-[color:var(--violet)]">{f.tagline_em || "little magic"}</em>
            {f.tagline_post || "?"}
          </h3>
          <a
            href="#contact"
            data-testid="footer-cta"
            className="mt-8 inline-flex items-center gap-2 mk-btn bg-[color:var(--violet)] text-white hover:opacity-90"
          >
            {f.cta_text || "Start a project"} <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-8">
          <div>
            <div className="text-xs uppercase tracking-wider text-[color:var(--bg)]/60">Menu</div>
            <ul className="mt-4 space-y-2">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="mk-link">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[color:var(--bg)]/60">
              Elsewhere
            </div>
            <ul className="mt-4 space-y-2">
              {socials.instagram && (
                <li>
                  <a className="mk-link" href={socials.instagram} target="_blank" rel="noreferrer">
                    Instagram
                  </a>
                </li>
              )}
              {socials.behance && (
                <li>
                  <a className="mk-link" href={socials.behance} target="_blank" rel="noreferrer">
                    Behance
                  </a>
                </li>
              )}
              {socials.linkedin && (
                <li>
                  <a className="mk-link" href={socials.linkedin} target="_blank" rel="noreferrer">
                    LinkedIn
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[color:var(--bg)]/60">Say hi</div>
            <ul className="mt-4 space-y-2">
              {site?.email && (
                <li>
                  <a className="mk-link" href={`mailto:${site.email}`}>
                    {site.email}
                  </a>
                </li>
              )}
              {site?.location && <li className="text-[color:var(--bg)]/70">{site.location}</li>}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-sm text-[color:var(--bg)]/60">
            &copy; {new Date().getFullYear()} {site?.name || "Misbah Khan"}. Made with care &amp; a
            lot of chai.
          </div>
          <div className="text-sm text-[color:var(--bg)]/60">
            {site?.tagline || "Humanising design, one pixel at a time."}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
